import { useEffect } from "react";

interface UseSeoOptions {
  title: string;
  description: string;
  keywords?: string;
  path: string;
  schemas?: object[];
}

const BASE = "https://fish3.cn";

function upsertMeta(attr: "name" | "property", key: string, content: string) {
  let el = document.head.querySelector<HTMLMetaElement>(`meta[${attr}="${key}"]`);
  if (!el) {
    el = document.createElement("meta");
    el.setAttribute(attr, key);
    document.head.appendChild(el);
  }
  el.setAttribute("content", content);
}

/** Sets per-page title / meta / canonical / schema (replaces on route change). */
export function useSeo({ title, description, keywords, path, schemas = [] }: UseSeoOptions) {
  useEffect(() => {
    document.title = title;
    upsertMeta("name", "description", description);
    if (keywords) upsertMeta("name", "keywords", keywords);
    upsertMeta("name", "robots", "index, follow");

    const url = `${BASE}${path}`;
    let canonical = document.head.querySelector<HTMLLinkElement>('link[rel="canonical"]');
    if (!canonical) {
      canonical = document.createElement("link");
      canonical.rel = "canonical";
      document.head.appendChild(canonical);
    }
    canonical.href = url;

    upsertMeta("property", "og:title", title);
    upsertMeta("property", "og:description", description);
    upsertMeta("property", "og:url", url);
    upsertMeta("name", "twitter:title", title);
    upsertMeta("name", "twitter:description", description);

    // replace page schema
    document.head.querySelectorAll('script[data-schema="page"]').forEach((n) => n.remove());
    schemas.forEach((schema) => {
      const s = document.createElement("script");
      s.type = "application/ld+json";
      s.setAttribute("data-schema", "page");
      s.textContent = JSON.stringify(schema);
      document.head.appendChild(s);
    });

    return () => {
      document.head.querySelectorAll('script[data-schema="page"]').forEach((n) => n.remove());
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [title, description, path]);
}